import React from 'react';

function Blockc({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "Arjun's Gandiv—The Divine Weapon",
        image: "images/main-attractions/block-c/block-c-1.png",
        description: `The divine Gandiv bow, gifted to Arjun by Varun Dev, symbolizes unmatched precision and power in battle. Arjun’s mastery of this weapon makes it one of the most honoured arms in ancient lore. The Gandiv stands for righteousness, discipline, and strength. The Swastika symbol above amplifies its spiritual energy, representing the cosmic cycle of creation, preservation and destruction.`,
      },
      {
        title: "Legends Of The Mahabharat",
        image: "images/main-attractions/block-c/block-c-8.png",
        description: `Prepare to enter a realm of untold tales from the Mahabharat . Here you will discover unseen moments of courage, sacrifice, moral conflict, and divine intervention that shaped the fate of the this epic. From warriors who embraced impossible duties to cosmic forces that altered destiny, each tale reveals a deeper layer of truth and dharm. As you move ahead, these narratives will connect you to the heart of the epic like never before.`,
      },
      {
        title: "Bheeshm's Bed of Arrows",
        image: "images/main-attractions/block-c/block-c-6.png",
        description: `At the war’s end, Jambudweep’s warriors faced immense loss. Bhishm, upon his bed of arrows, chose to depart in Uttarayan. Troubled by doubts of kingship, Yudhishthir sought his counsel. Bhishm imparted the essence of Rajdharm. His timeless wisdom remains deeply relevant even today.`,
        label: "Main Attraction",
      },
      {
        title: "Dating of Mahabharat",
        image: "images/main-attractions/block-c/block-c-7.png",
        description: `The Mahabharat’s dating remains debated—history or myth, fact or imagination. Vyas’s text mentions celestial events matching modern calculations, placing the war 4000–5000 years ago. Excavations of submerged Dwarka provide further evidence. Though its exact timing remains uncertain, the epic endures, inspiring humanity with timeless lessons on dharma and truth.`,
        label: "Main Attraction",
      },
      {
        title: "Ancient Artefacts",
        image: "images/main-attractions/block-c/block-c-5.png",
        description: `These artefacts dated back to before the 10th century – each one telling a fascinating story from our glorious past.`,
        label: "Main Attraction",
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "अर्जुन गाँडीव-दिव्य शस्त्र",
        image: "images/main-attractions/block-c/block-c-1.png",
        description: `अर्जुन को वरुण देव द्वारा दिया गया गांडीव उसकी अद्भुत युद्धकौशल और निशानेबाज़ी की पहचान है। यह धनुष न केवल शक्ति का प्रतीक है, बल्कि धर्म और अनुशासन का भी संदेश देता है। छत पर बना स्वस्तिक चिन्ह इस अस्त्र की आध्यात्मिक महत्ता को दर्शाता है और ब्रह्मांड के सृजन, पालन और संहार के चक्र का प्रतीक है।`,
      },
      {
        title: "महाभारत की किंवदंतियाँ",
        image: "images/main-attractions/block-c/block-c-8.png",
        description: `महाभारत की अनकही गाथाओं के पावन लोक में आपका स्वागत है  यहाँ आप वीरता, बलिदान, धर्मसंकट और दैवी लीला के वे दुर्लभ प्रसंग जानेंगे जिन्होंने इस महाकाव्य के भाग्य की दिशा निर्धारित की।  वे वीर जिन्होंने असंभव कर्तव्यों को स्वीकारा और वे ब्रह्मांडीय शक्तियाँ जिन्होंने भाग्य की दिशा बदल दीं ।  हर कथा धर्म और सत्य के एक गहरे आयाम को उजागर करती है। आगे बढ़ते हुए, ये प्रसंग आपको महाभारत के हृदय से पहले से कहीं अधिक गहराई से जोड़ देंगे। `,
      },
      {
        title: "भीष्म शरशय्या",
        image: "images/main-attractions/block-c/block-c-6.png",
        description: `महाभारत युद्ध में जम्बूद्वीप के वीरों को भारी क्षति हुई। पितामह भीष्म शरशय्या पर उत्तरायण में देह त्याग कर गए। युद्ध के बाद संशयग्रस्त युधिष्ठिर को उन्होंने राजधर्म के सिद्धांत बताए। उनका यह अमर उपदेश आज भी प्रेरणादायी है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महाभारत का काल निर्धारण",
        image: "images/main-attractions/block-c/block-c-7.png",
        description: `महाभारत की तिथि पर सदियों से विवाद है- इतिहास या मिथक, यथार्थ या कल्पना। वेदव्यास द्वारा वर्णित ग्रह-नक्षत्र स्थितियाँ आधुनिक गणनाओं से मेल खाकर युद्ध को 4000-5000 वर्ष पूर्व मानती हैं। समुद्र में डूबी द्वारका के प्रमाण भी इसकी गवाही देते हैं। तिथि अनिश्चित, संदेश शाश्वत ।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "प्राचीन कलाकृतियाँ ",
        image: "images/main-attractions/block-c/block-c-5.png",
        description: `ये कलाकृतियाँ 10वीं शताब्दी से भी पहले की हैं — प्रत्येक अपने भीतर हमारे गौरवशाली अतीत की एक अद्भुत कहानी समेटे हुए है।`,
        label: "मुख्य आकर्षण",
      },
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blockc-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blockc;
